/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconCollapse = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M9.369 9.999 3 3.953 3.918 3l6.362 6.04-.115-4.41 1.337-.035.173 6.681-6.681.174-.035-1.336 4.41-.115ZM14.631 13.6 21 19.646l-.919.953-6.36-6.04.114 4.41-1.337.035-.173-6.681 6.681-.174.035 1.336-4.41.115Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconCollapse.displayName = 'IconCollapse';
export default IconCollapse;
